


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
//import { Design} from './designTest/designTest.model';

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
  Is_Logged: string;

}
interface TokenResponse {
  token: string;
}

export interface Category {
  category_name: string;
}
export interface Type {
  type: string;
}
export interface Complexity {
  complexity: string;
}
export interface Item {
    questionsetname: string;
   }
export interface TokenPayload {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: string;
  role_id: string;
  Is_Logged: string;

}
export interface Edit {
  email: string;
}

export interface UserType {
  type: string;
}

export interface TestData {
  id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Type: string;
}

@Injectable()
export class LoginService {
  private token: string;

  constructor(private http: HttpClient) {}

  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
    //
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }
  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }
  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }



  setCurrentUser(user) {
    user.isLoggedIn = true;
    user.first_name = user.getUserDetails.first_name;
    user.last_name = user.getUserDetails.last_name;
    user.email = user.getUserDetails.email;
    user.phone = user.getUserDetails.phone;
    user.type = user.getUserDetails.type;
  }



// Login
public login(user: TokenPayload): Observable<any> {

  const base = this.http.post('/users', user);


  const request = base.pipe(
    map((data: TokenResponse) => {


      if (data.token) {
        this.saveToken(data.token);
      }


      return data;
    })
  );
  return request;
}






// question category
  public category(user: Category): Observable<any> {

    const base = this.http.post('/users/category', user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }



}



